import * as React from 'react';
import { Checkbox as AntCheckbox } from 'antd';

export type CheckboxProps = {
  children?: React.ReactNode | string;
  autoFocus: boolean;
  checked: boolean;
  defaultChecked: boolean;
  disabled: boolean;
};

const Checkbox = (props: CheckboxProps & Partial<React.ComponentProps<typeof AntCheckbox>>) => {
  const { className } = props;
  const classNames = [className, 'checkbox'];
  return <AntCheckbox {...props} className={classNames.join(' ')} />;
};

Checkbox.defaultProps = {
  checked: undefined,
  autoFocus: false,
  defaultChecked: false,
  disabled: false,
};

export default Checkbox;
